module.exports = __webpack_public_path__ + "media/svg-new/icon-alert-exclamation-77a7e6b5.svg";